import React from 'react';
import { withProps, compose, pure, withHandlers, defaultProps } from 'recompose';
import { prop } from 'ramda';
import { Game as CommonGame, GAME_LAUNCH_TYPE } from 'js/components/main/CasinoGame';
import { PlayButton, DemoButton, tKeyPrefix } from 'js/components/main/CasinoGame/Buttons';
import { useDeviceSelector } from 'js/store/hooks';
import { getLocationParam } from 'js/utils/url.util';
import { StatusBadge } from '../../common/StartStatusBadge';
import { RACE_RULE_STATUSES } from '../../constants';
import style from './index.scss';
import { usePortletTranslations } from '../../../../system/Portlet';
import CountDownBadge from '../../common/CountDown/CountDownBadge';
import withGameLaunch from 'js/components/common/Game/withGameLaunch';
import classNames from '../classNames';
import { Link } from 'js/components/common/Link';

export const GameStatusBadge = withProps(
    ({ status: ruleStatus }) => {
        const tkPrefix = 'playtech.mobile.casino-leaderboard-page.';

        return {
            status: ruleStatus === RACE_RULE_STATUSES.approved ? 'notStarted' : ruleStatus.toLowerCase(),
            tKeyPrefix: `${tkPrefix}gameItem.status.`
        };
    }
)(StatusBadge);

export const PlayButtonWrapper = ({
                                      code, gameLaunchType, isMissions, hideButtons, isDesktop,
                                      isShowPlayButtonOnHover, trackChangeGameClick, gameIndexInArray, rest
                                  }) => {
    const definePlayButtonWrapperStyle = () => {
      return isMissions && hideButtons ? style.playButtonWrapperNoPlay : style.playButtonWrapper;
    };
    return <div className={definePlayButtonWrapperStyle()}>
        <PlayButton code={code} isHoverBtn={true} gameLaunchType={gameLaunchType}
                    isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                    trackChangeGameClick={trackChangeGameClick}
                    gameIndexInArray={gameIndexInArray}
                    isMissions={true}
                    hideButtons={hideButtons}
                    isDesktop={isDesktop}
                    {...rest}/>
    </div>;
};

export const HoveredGame = ({ code, name, showDemoButton, hideButtons, gameLaunchType, isShowGameName,
                                isShowPlayButtonOnHover, trackChangeGameClick, gameIndexInArray, isInMissionsItemCard }) => (
    <div className={style.hovered}>
        {isShowGameName ? <div className={style.title}>{name}</div> : <></>}
        {!hideButtons &&
        <div className={style.buttons}>
            {showDemoButton && <DemoButton code={code} name={name} isHoverBtn={true} gameLaunchType={gameLaunchType} />}
            {!isInMissionsItemCard && <PlayButton code={code} name={name} isHoverBtn={true}
                                                  gameLaunchType={gameLaunchType}
                                                  isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                                                  trackChangeGameClick={trackChangeGameClick}
                                                  gameIndexInArray={gameIndexInArray}/>}
        </div>
        }
    </div>
);

export const Game = ({ status, code, className, isDesktop, setGameRef, hideButtons, gameLaunchType, imageClassName,
                         isShowGameName, isShowPlayButtonOnHover, imageComponentOnHover, isGameIsNotEarnPoints,
                         timeToStartEarnPoints, isGameFromEndedRule, timerTitleText, trackChangeGameClick,
                         gameIndexInArray, isInMissionsItemCard, missionNoGamesImage, urlMission, ...rest }) => {

    return missionNoGamesImage ?
        <Link
            href={urlMission}
            inNewWindow={true}
            className={classNames(style.game, className, { [style.gameNoUrl]: !urlMission })}>
                <div className={classNames(style.noGamesImageWrapper, { [style.grayedOut]: isGameIsNotEarnPoints })}>
                    <div className={style.noGamesImage}>
                        <img alt={'image'} src={missionNoGamesImage} className={style.sourceNoGamesImage}/>
                    </div>
                </div>
                {isDesktop && !hideButtons && !isGameIsNotEarnPoints && !isGameFromEndedRule && urlMission
                && <HoveredGame code={code} isShowGameName={isShowGameName}
                                gameLaunchType={gameLaunchType}
                                hideButtons={hideButtons}
                                isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                                trackChangeGameClick={trackChangeGameClick}
                                gameIndexInArray={gameIndexInArray}
                                isInMissionsItemCard={isInMissionsItemCard}
                                {...rest} />}
            {isGameIsNotEarnPoints && <div className={style.availableInGame}/>}
        </Link> :
        <div className={classNames(style.game, className,
            { [style.gameHideButtons]: isInMissionsItemCard && hideButtons })} ref={setGameRef}>
        <CommonGame {...{
            code,
            hideButtons,
            gameLaunchType,
            showTitle: false,
            imageClassName,
            isGameIsNotEarnPoints,
            isGameFromEndedRule,
            isRelativeSize: true,
            showRecentlyPlayedIcon: false,
            showFavoriteIcon: false,
            showFeatureIcons: false,
            showGameInfo: false,
            disableGameLaunch: hideButtons,
            size: 'medium',
            isInH2SPages: true
        }} />
        {status && <GameStatusBadge className={style.badge} status={status}/>}
        {isInMissionsItemCard && code && !isGameIsNotEarnPoints && !isGameFromEndedRule && !hideButtons &&
        <PlayButtonWrapper code={code} isHoverBtn={true} gameLaunchType={gameLaunchType}
                           isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                           trackChangeGameClick={trackChangeGameClick}
                           gameIndexInArray={gameIndexInArray}
                           isMissions={true}
                           hideButtons={hideButtons}
                           isDesktop={isDesktop}
                           {...rest}/>}
        {isDesktop && !hideButtons && !isGameIsNotEarnPoints && !isGameFromEndedRule
        && <HoveredGame code={code} isShowGameName={isShowGameName}
                        gameLaunchType={gameLaunchType}
                        hideButtons={hideButtons}
                        isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                        trackChangeGameClick={trackChangeGameClick}
                        gameIndexInArray={gameIndexInArray}
                        isInMissionsItemCard={isInMissionsItemCard}
                        {...rest} />}
        {(isGameIsNotEarnPoints || isGameFromEndedRule) && <div className={classNames(style.availableInGame,
            { [style.missionsAvailableInGame]: isInMissionsItemCard })}/>}
        {(isGameIsNotEarnPoints || isGameFromEndedRule) && !isGameFromEndedRule && !isInMissionsItemCard
        && <div className={style.availableInGameContent}>
            <div className={style.availableInGameText}> {`${timerTitleText}`}
                <br/>
                <div className={style.boltValue}>
                    <CountDownBadge endTime={Date.now() + timeToStartEarnPoints}
                                    startTime={Date.now()}
                                    importedStyle={style}
                                    isGameCounter={true}
                    />
                </div>
            </div>
        </div>}
    </div>;
};

export default compose(
    pure,
    defaultProps({
        mode: 1,
        className: '',
        tKey: `${tKeyPrefix}.realPlay`
    }),
    withGameLaunch,
    withHandlers({
        launchGame: ({ launchGame, trackChangeGameClick, gameIndexInArray, code }) => (data) => {
            if (trackChangeGameClick) {
                trackChangeGameClick(code, gameIndexInArray);
            }
            launchGame(data);
        }
    }),
    withProps(
        ({ className, imageClassName, isShowGameName, isShowPlayButtonOnHover, trackChangeGameClick,
             gameIndexInArray, isInMissionsItemCard, missionNoGamesImage, urlMission }) => {
            const isDesktop = useDeviceSelector(prop('isDesktop'));
            const hideButtons = getLocationParam('showGameSwitch') === '0';
            const gameLaunchType = getLocationParam('showGameSwitch') === '1' ? GAME_LAUNCH_TYPE.Casino : GAME_LAUNCH_TYPE.Default;
            const t = usePortletTranslations();
            const timerTitleText = t('availablein');

            return {
                className,
                imageClassName,
                isDesktop,
                hideButtons,
                gameLaunchType,
                isShowGameName,
                isShowPlayButtonOnHover,
                timerTitleText,
                trackChangeGameClick,
                gameIndexInArray,
                isInMissionsItemCard,
                missionNoGamesImage,
                urlMission
            };
        }
    )
)(Game);
